import { initializeApp } from 'firebase/app';
import { getAuth,PhoneAuthProvider,signInWithCredential} from 'firebase/auth';
import { getDatabase,ref, set,get,onValue,update, remove,doc,getDoc  } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCP07Au4xZ2NPmcE7T7wJU4wrkqYAmgmUA",
  authDomain: "altrange-dashboard-81282.firebaseapp.com",
  databaseURL: "https://altrange-dashboard-81282-default-rtdb.firebaseio.com",
  projectId: "altrange-dashboard-81282",
  storageBucket: "altrange-dashboard-81282.appspot.com",
  messagingSenderId: "39124649407",
  appId: "1:39124649407:web:fb00003ebccc883d91cd0a",
  measurementId: "G-P6DSBED5R4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);
const storage = getStorage(app);


export { storage, app, auth, db ,ref, set,get, remove,storageRef,onValue ,update, uploadBytes, getDownloadURL,PhoneAuthProvider,signInWithCredential};